export default __webpack_public_path__ + "static/national-yards-mobile-54a9fb8c79b0351ec986655d8dbfc7cb.svg";